import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

export const ERRORS = {
  NOT_FOUND: 1,
  REDEEMED: 2,
  UNAVAILABLE: 3,
  UNREDEEMABLE: 4
};

class PromocodeDialog extends Component {
  render() {
    const { t } = this.props;
    return(
      <div>
        <button
          className="hidden"
          data-target="#modalPromocode"
          data-toggle="modal"
          id="btnPromocode"
          type="button"
          onClick={this.props.handleClearPromocode}>
        </button>
        <div className="modal fade" id="modalPromocode" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button className="close" data-dismiss="modal" type="button" >&times;</button>
                <h4 className="modal-title">{t('dashboard.room_payment.promocode_title')}</h4>
              </div>
              <div className={ (!this.props.user.no_account || this.props.user.email) ? "hidden" : ""}>
                <div className="modal-body">
                  <p>{t('dashboard.room_payment.missing_email')}</p>
                </div>
                <div className="modal-footer"></div>
              </div>
              <div className={ (this.props.user.no_account && !this.props.user.email) ? "hidden" : "modal-body"}>
                <form method="post" onSubmit={this.props.handlePromocodeSubmit}>
                  <fieldset>
                    <div className="form-group">
                      <input
                        className="form-control"
                        onChange={this.props.handlePromocodeChange}
                        placeholder={t('dashboard.room_payment.holder_promocode')}
                        type="text"
                        value={this.props.promocode} />
                    </div>
                    <div className={this.props.promocodeError ? "" : "hidden"}>
                      <div className="alert alert-warning">
                        {this.props.promocodeError}
                        <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearPromocode} />
                      </div>
                    </div>
                    <div className="form-group text-center">
                      <button
                        className="btn btn-primary"
                        disabled={!this.props.promocode}
                        type="submit">
                        {t('dashboard.room_payment.btn_promocode')}
                      </button>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(PromocodeDialog);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/payment/PromocodeDialog.js